/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TestJobParams } from './testJobParams';

/**
 * Request model for test job
 */
export interface RunTestJobRequest {
  type: 'test';
  params: TestJobParams;
  allowOverlappingJobs?: boolean;
}
